import React, { ElementType } from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';

const StyledLabel = styled.label`
  display: inline-block;
  font-weight: 600;
  font-size: ${rem(16)};
  margin-bottom: ${rem(4)};
`;

const Label = ({
  id,
  children,
  isRequired,
  as,
}: {
  id?: string;
  children: string;
  isRequired?: boolean;
  as?: ElementType<any>;
}) => {
  return (
    <StyledLabel htmlFor={id} as={as}>
      {children}
      {isRequired ? '*' : ''}
    </StyledLabel>
  );
};

export default Label;
